import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './end_now.less'
import StandardError from 'components/common/standard_error'

const i18n = getI18n('components/edit_glimpse/end_pool')

class EndNow extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string.isRequired,
    onEndNow: PropTypes.func.isRequired,
    error: PropTypes.any,
  }

  render() {
    if (this.props.error) {
      return (
        <StandardError
          iconType="warning"
          title={i18n('error_title')}
          subtitle={i18n('error_subtitle')}
          showButton={true}
          onTryAgain={this.props.onEndNow}
        />
      )
    }
    return (
      <div>
        <span
          className="icon icon-large icon-attention-large"
          styleName="end-indicator"
        />
        <div styleName="title">{i18n('title')}</div>
        <div styleName="description">{i18n('description')}</div>
        <button
          data-pa-click="end"
          className="vx_btn vx_btn-block"
          onClick={this.props.onEndNow}
        >
          {i18n('end_pool')}
        </button>
      </div>
    )
  }
}

export default cssModules(EndNow, styles)
